<template>
  <div class="home_page" :class="{'fixed_page': showJc }">
    <img class="index_bg" :class="{'reach': reach}" src="../../assets/version_1.3.0/index/linear.png" alt="">
    <!-- 头部 -->
    <div class="header" :class="{'reach': reach}">
      <div class="header-inner">

        <a href="https://bbs.3975.com/" v-if="$route.query.from&&$route.query.from!='null'">
          <van-icon name="arrow-left" color="#fff" size="2rem" class="left_icon"/>
        </a>
        <div class="right-wrap" @click="gotoSearch">
          <img class="search_icon" src="../../assets/version_1.3.0/index/search_icon.png" alt="">
          <van-swipe :show-indicators="false" :vertical="true" :autoplay="words.length == 1 ? 0 : 5000"
            :touchable="false" @change="changeSwipe">
            <van-swipe-item v-for="(item,i) in words" :key="i">{{ item.app_name }}</van-swipe-item>
          </van-swipe>
        </div>
        <div class="key" @click="openKey"></div>
        <div class="msg" :class="{'hasmsg': hasmsg}" @click="gotoMsg">
          <img class="msg_icon" src="../../assets/version_1.3.0/index/msg.png" alt="">
        </div>
      </div>
    </div>
    <!-- banner -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" ref="home">
      <div class="banner_area">
        <div class="banner">
          <van-swipe indicator-color="#fff" :autoplay="3000">
            <van-swipe-item v-for="(item,i) in banner" :key="i">
              <a :href="item.url == '' ? 'javascript:;' : item.url" @dragstart.prevent>
                <van-image :src="item.banner"></van-image>
              </a>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- icon -->
      <swiper class="icon-wrap" :options="swiperOption">
        <div class="swiper-wrapper swiper-no-swiping">
          <swiper-slide class="icon-inner">
            <div class="item" @click="gotoMarket(1)">
              <img src="../../assets/version_1.3.0/index/icon1.png" alt="" />
              <p>道具</p>
            </div>
          </swiper-slide>
          <swiper-slide class="icon-inner">
            <div class="item" @click="gotoMarket(2)">
              <img src="../../assets/version_1.3.0/index/icon2.png" alt="" />
              <p>角色</p>
            </div>
          </swiper-slide>
          <swiper-slide class="icon-inner">
            <div class="item" @click="$router.push({name: 'rank',params: {sort: 'rec'}})">
              <img src="../../assets/version_1.3.0/index/icon3.png" alt="" />
              <p>游戏</p>
            </div>
          </swiper-slide>
          <swiper-slide class="icon-inner jqqd">
            <div class="item" @click="$toast('敬请期待')">
              <img src="../../assets/version_1.3.0/index/icon4.png" alt="" />
              <p>签到</p>
            </div>
          </swiper-slide>
        </div>
      </swiper>
      <!-- 速看 -->
      <div class="teenager">
        <div class="left">
          <img src="../../assets/version_1.3.0/index/G_icon.png" alt="">
          <span>速看</span>
        </div>
        <div class="right">
          <van-swipe :show-indicators="false" :vertical="true" :autoplay="5000">
            <van-swipe-item v-for="(item,i) in quickList" :key="i" @click="gotoDetail(item.goods_type,item.id,item.app_name,item.icon,item.app_id,item.server_id,item.server_name)">
              <div v-html="item.content"></div>
            </van-swipe-item>
          </van-swipe>
        </div>

      </div>
      <!-- 道具爆卖 -->
      <div class="game-wrap" v-if="propHot.length > 0">
        <div class="wrap-title">
          <span class="title">道具爆卖</span>
          <span class="more" @click="gotoMarket(1)">更多
            <van-icon name="arrow" /></span>
        </div>
        <swiper class="games-swiper" :options="swiperOption">
          <!-- swiper-no-swiping -->
          <div class="swiper-wrapper">
            <swiper-slide v-for="(item, i) in propHot" :key="i" class="game-slide">
              <div class="game-item" @click="gotoHome(item.app_name,item.icon,item.app_id,item.prop_trade,item.role_trade,1,0,item.server_id,item.server_name)">
                <van-image :src="item.icon"></van-image>
                <div class="name">{{ item.app_name }}</div>
              </div>
            </swiper-slide>
          </div>
        </swiper>
      </div>
      <!-- 角色爆卖 -->
      <div class="game-wrap" v-if="roleHot.length > 0">
        <div class="wrap-title">
          <span class="title">角色爆卖</span>
          <span class="more" @click="gotoMarket(2)">更多
            <van-icon name="arrow" /></span>
        </div>
        <swiper class="games-swiper" :options="swiperOption">
          <!-- swiper-no-swiping -->
          <div class="swiper-wrapper">
            <swiper-slide v-for="(item, i) in roleHot" :key="i" class="game-slide">
              <div class="game-item" @click="gotoHome(item.app_name,item.icon,item.app_id,item.prop_trade,item.role_trade,0,1)">
                <van-image :src="item.icon"></van-image>
                <div class="name">{{ item.app_name }}</div>
              </div>
            </swiper-slide>
          </div>
        </swiper>
      </div>
      <!-- 为您推荐 -->
      <div class="recommend">
        <p class="title">为您推荐</p>
        <rec-scroll url="index/recommend" ref="rec" method="get">
          <template slot-scope="scope">
            <rec-box v-for="(item,i) in scope.data" :item="item" :key="i" />
          </template>
        </rec-scroll>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
  import "swiper/dist/css/swiper.css";
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  import $ from 'jquery'
  import RecBox from './box/RecBox.vue'
  export default {
    components: {
      swiper,
      swiperSlide,
      RecBox
    },
    props: ["showJc"],
    data() {
      return {
        banner: [],
        isLoading: false,
        swiperOption: {
          slidesPerView: "auto",
          freeMode: true, // 随意拖动位置
          mousewheel: false,
        },
        quickList: [], //G速看
        propHot: [], //道具爆卖
        roleHot: [], //热门游戏
        screenWidth: window.innerWidth,

        hasmsg: false, //消息中心有消息
        timer: null, //轮询的timer
        reach: false,
        words: [],//
        words_index: 0,
      };
    },
    computed: {
      isLogin() {
        return this.$store.getters.isLogin;
      },
      isApp() {
        return this.$store.state.isApp
      },
      isAndroid() {
        var u = navigator.userAgent;
        if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
          return true
        } else {
          return false
        }
      },
      isiOS() {
        var u = navigator.userAgent;
        if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
          return true
        } else {
          return false
        }
      }
    },
    created() {
      var that = this
      window.addEventListener('resize', () => {
        that.screenWidth = window.innerWidth
      })
      // this.$emit('changeJc',true)
    },
    mounted() {
      this.getBanner()
      
      if (this.isLogin) {
        this.settimeout();
      }
      if (this.$route.query.from) {
        window.localStorage.setItem('indexfrom', this.$route.query.from)
      } else {
        window.localStorage.setItem('indexfrom', '')
      }
      window.addEventListener('scroll', this.handleScroll)
    },
    activated() {
      this.words_index = 0
      this.getIndex()
      this.getHotList()
    },
    methods: {
      //前往具体游戏 道具/角色市场
      gotoHome(name, icon, id, prop_trade, role_trade,prop,role,server_id,server_name) {
        this.$store.commit('resetServer')
        this.$store.commit('resetHomeServer')
        this.$store.commit('setGameInfo', {
          name,
          icon,
          id
        })
        if(server_id) {
          this.$store.commit('bindHomeServer',{
            server_id,
            server_name
          })
        }
        
        this.$store.commit('setCt', '')
        this.$store.commit('setCi', '')
        this.$store.commit('setCt2', '')
        this.$store.commit('setCi2', '')
        //道具市场 角色市场判断
        this.$store.commit('setHome', {
          prop_trade,
          role_trade
        })
        if(role == 1) {
          this.$store.commit('changeHome', 2)
        } 
        if(prop == 1) {
          this.$store.commit('changeHome', 1)
        }
        //角色市场 筛选全部重置
        this.$store.commit('resetAccPx')

        if(this.isiOS) {
          window.location.href = window.location.origin + '/home?id=' + id
        }else {
          this.$router.push({
            name: 'home',
            query: {
              id: id
            }
          })
        }
      },
      //前往市场首页  道具/角色
      gotoMarket(i) {
        this.$store.commit('setMarketOtype', i)
        this.$router.push({
          name: 'market'
        })
      },
      //轮询
      settimeout() {
        this.getMsg();
        this.timer = window.setInterval(() => {
          setTimeout(() => {
            this.getMsg();
          }, 0);
        }, 10000);
      },
      getMsg() {
        this.$Ajax('index/check-redpoint', {}, 'get').then(rs => {
          if (rs.code == 200) {
            if (Number(rs.data.count) > 0) {
              this.hasmsg = true
            } else {
              this.hasmsg = false
            }
          }
        })
      },
      getBanner() {
        this.$Ajax('h5/banner-list', {}, 'get').then(rs => {
          if (rs.code == 200) {
            this.banner = rs.data
          }
        })
      },
      getIndex() {
        this.$Ajax('index/index', {}, 'get').then(rs => {
          if (rs.code == 200) {
            this.quickList = rs.data.quickList
            this.propHot = rs.data.propHot
            this.roleHot = rs.data.roleHot
          }
        })
      },
      //前往游戏详情
      goDetail(id) {
        this.$router.push({
          path: "/detail",
          query: {
            app_id: id,
          },
        });
      },

      onRefresh() {
        setTimeout(() => {
          this.isLoading = false;
          this.getBanner()
          this.getIndex()
          this.getHotList()
          this.$refs.rec.refresh()
        }, 1000);
      },

      handleScroll(event) {
        if($('.banner')[0]&& $('.banner')[0].clientHeight) {
          var target = $('.banner')[0].clientHeight
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          if (scrollTop > target) {
            this.reach = true
          } else {
            this.reach = false
          }
        }
      },

      gotoMsg() {
        if (this.isLogin) {
          this.$Ajax('index/last-click')
          this.$router.push({
            name: 'user.msg'
          })
        } else {
          this.$filterPop({
            type: "login",
            direction: 'up',
            onSuccess: () => {
              this.$Ajax('index/last-click')
              this.$router.push({
                name: 'user.msg'
              })
            }
          });
        }
      },
      gotoDetail(goods_type,goods_id,name, icon, id,server_id,server_name) {
        if(goods_type == 1) {
            this.$store.commit('setGameInfo', {
              name,
              icon,
              id
            })
            this.$store.commit('bindHomeServer',{
              server_id,
              server_name
            })
            this.$router.push({
                name: 'order',
                query: {
                    id: goods_id
                }
            })
        }else {
            this.$router.push({
                name: 'acc.goods',
                query: {
                    goods_id
                }
            })
        }
      },

      //搜索框里的placeholder轮播
      changeSwipe(index) {
        this.words_index = index
      },
      //获取推荐列表
      getHotList() {
        this.$Ajax("index/hot-apps", {}, "get").then((rs) => {
          if (rs.code == 200) {
            this.words = rs.data.slice(0, 10)
          }
        });
      },
      gotoSearch() {
        var that = this
        this.$router.push({ 
          name: 'resultSearch',
          query: {
            index: that.words_index
          } 
        })
      },
      openKey() {
        this.$RModal.key({
          noheader:true
        })
      }
    },
    watch: {},
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    beforeRouteLeave (to, from, next) {
      next()
      if(this.timer) {
        clearInterval(this.timer);
        this.timer = null
      }
    }
  };
</script>

<style lang="less" scoped>
  .index_bg {
    width: 100%;
    max-width: 525px;
    position: fixed;
    top: -2.7rem;
    left: 50%;
    transform: translateX(-50%);
    opacity: 1;
    transition: all ease .5s;

    &.reach {
      opacity: 0;
    }
  }

  .header {
    width: 100%;
    height: 6.4rem;
    position: fixed;
    top: 0;
    left: 50%;
    width: 100%;
    padding: 2rem 1rem 1rem;
    max-width: 525px;
    z-index: 100;
    transform: translateX(-50%);
    text-align: center;
    overflow: hidden;
    background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
    transition: all ease .5s;

    &.reach {
      background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -12rem / 100% 26.2rem;
      background-color: #fff;
    }

    .header-inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // background: linear-gradient(33deg, #ff625a 0%, #df5f56 80%);

      .left_icon {
        margin-right: .9rem;
        cursor: pointer;
      }

      .right-wrap {
        flex: 1;
        height: 3.4rem;
        border-radius: 10rem;
        // margin: 1.4rem 1.5rem;
        line-height: 3.4rem;
        background-color: #fff;
        color: #ccc;
        text-align: left;
        cursor: pointer;
        padding: 0 1rem;
        display: flex;
        align-items: center;
        overflow: hidden;
        position: relative;
        .search_icon {
          width: 1.8rem;
          height: 1.8rem;
          margin-right: 1rem;
        }

        span {
          font-size: 1.4rem;
        }

        .van-swipe {
          position: absolute;
          top: 0;
          left: 4rem;
          width: 26rem;
          z-index: 10;
          .van-swipe-item {
            font-size: 1.4rem;
            color: #999;
            text-align: left;
          }
        }
      }
      .key {
        width: 2.3rem;
        height: 2.3rem;
        cursor: pointer;
        background: url(../../assets/version_1.3.0/index/key.png) no-repeat 0 0 / 100% 100%;
        margin-left: .7rem;
      }
      .msg {
        margin-left: .7rem;
        padding-right: .2rem;
        cursor: pointer;
        &.hasmsg {
          position: relative;

          &::after {
            position: absolute;
            right: 0;
            top: 0;
            content: '';
            width: .7rem;
            height: .7rem;
            background-color: var(--red);
            border-radius: 50%;
          }
        }

        .msg_icon {
          width: 2.2rem;
          height: 2.3rem;
        }
      }
    }
  }

  .van-pull-refresh {
    margin-top: 6.4rem;
    max-width: 525px;
  }

  .banner_area {
    height: 14rem;
  }

  .banner {
    width: 35.5rem;
    height: 14rem;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 1rem;

    .van-image {
      height: 14rem;
      border-radius: 1rem;
      overflow: hidden;
    }

    /deep/.van-swipe__indicators {
      .van-swipe__indicator {
        width: .8rem;
        height: .8rem;
        border: .1rem solid #fff;
        background-color: transparent;
        margin: 0 .5rem;

        .van-swipe__indicator--active {
          background-color: #fff;
        }
      }
    }
  }

  .icon-wrap {
    margin: 1rem;

    /deep/.swiper-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
    }

    .icon-inner {
      cursor: pointer;
      width: 6.5rem;

      &.jqqd {
        position: relative;

        &::after {
          content: '敬请期待';
          position: absolute;
          right: 0;
          top: 0;
          width: 6.4rem;
          padding: 0 .6rem;
          font-size: 1.6rem;
          background: linear-gradient(320deg, #FF3B50 0%, #FF7886 100%);
          color: #fff;
          border-radius: 10rem;
          transform: scale(0.5);
          transform-origin: 100% 0;
          white-space: nowrap;
        }
      }

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      img {
        width: 4.4rem;
        height: 4.4rem;
      }

      p {
        font-size: 1.2rem;
        padding-top: 1rem;
        color: #555;
      }
    }
  }

  .game-wrap {
    margin: 0 1rem 1.2rem;
    overflow: hidden;

    .wrap-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1.2rem;

      .title {
        font-size: 1.6rem;
        color: #000;
        font-weight: 700;
      }

      .more {
        font-size: 1.4rem;
        color: #606060;
      }
    }

    .games-swiper {
      .game-slide {
        width: 6rem;
        margin-right: 1.4rem;
        cursor: pointer;

        .game-item {
          display: flex;
          align-items: center;
          flex-direction: column;
        }

        .van-image {
          width: 6rem;
          height: 6rem;
          border-radius: 1rem;
          overflow: hidden;
        }

        .name {
          color: #606060;
          font-size: 1.2rem;
          margin-top: 0.25rem;
          width: 6rem;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }

  .teenager {
    margin: 1.1rem 1rem;
    padding: 0 1.2rem 0 9.2rem;
    height: 5.4rem;
    background-color: rgba(255, 110, 42, 0.04);
    border-radius: 1rem;
    overflow: hidden;
    position: relative;

    .left {
      width: 6.7rem;
      // display: flex;
      // align-items: center;
      // padding-right: 1.1rem;
      position: absolute;
      left: 1rem;
      top: 50%;
      transform: translateY(-50%);

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 2.5rem;
        background-color: #ffcf9f;
      }

      img {
        width: 2.6rem;
        height: 2.7rem;
      }

      span {
        font-size: 1.5rem;
        font-weight: 700;
        color: #454140;
        margin-left: .3rem;
      }
    }

    .right {

      overflow: hidden;
    }

    /deep/.van-swipe-item {
      // display: flex;
      // align-items: center;
      // text-align: start;
      color: #000;
      font-size: 1.2rem;
      padding-top: 1.2rem;

      div {
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }

  .recommend {
    padding: 0 1rem;

    .title {
      font-size: 1.6rem;
      color: #000;
      font-weight: 700;
      margin-bottom: 1.2rem;
    }
  }

  .home_page {
    overflow: hidden;
  }

</style>